import { TYPES } from 'action-types/fcr';
import { IDocumentDetail, EmptyDocumentDetail } from './models';

interface IAction {
  readonly type: string;
  readonly documentDetails: IDocumentDetail;
  readonly documents: any;
  readonly errors: string;
}
export interface IDocumentState {
  readonly isFetchDataLoading: boolean;
  readonly isFetchDataError: boolean;
  readonly detailsPendingError: string;
  readonly documentDetails: IDocumentDetail;
  readonly documents: any;
}

export const defaultState: IDocumentState = {
  isFetchDataLoading: false,
  isFetchDataError: false,
  detailsPendingError: '',
  documentDetails: EmptyDocumentDetail,
  documents: {
    pageNumber: 1,
    page: 1,
    pageSize: 0,
    result: [],
    totalCount: 0,
  },
};

export const reducer = (
  state: IDocumentState = defaultState,
  action: IAction
): IDocumentState => {
  switch (action.type) {
    case TYPES.RESET_FCR.PENDING:
      return {
        ...state,
        isFetchDataError: false,
        detailsPendingError: '',
      };
    case TYPES.RESET_FCR.FULFILLED:
      return {
        ...state,
        documents:
          action.documents && action.documents.length === 0
            ? defaultState.documents
            : action.documents,
      };
    case TYPES.FETCH_FCR.PENDING:
      return {
        ...state,
        isFetchDataError: false,
        isFetchDataLoading: true,
        detailsPendingError: '',
        documentDetails: defaultState.documentDetails,
      };
    case TYPES.FETCH_FCR.FULFILLED:
      return {
        ...state,
        isFetchDataLoading: false,
        documents:
          action.documents && action.documents.result
            ? action.documents
            : defaultState.documents,
      };
    case TYPES.FETCH_FCR.REJECTED:
      return {
        ...state,
        isFetchDataError: true,
        isFetchDataLoading: false,
        detailsPendingError: action.errors,
      };
    case TYPES.FETCH_FCR.RESET_ERROR:
      return {
        ...state,
        isFetchDataError: true,
        detailsPendingError: action.errors,
      };
    case TYPES.FETCH_FCR_DETAILS.PENDING:
      return {
        ...state,
        isFetchDataError: false,
        isFetchDataLoading: true,
        detailsPendingError: '',
        documentDetails: defaultState.documentDetails,
      };
    case TYPES.FETCH_FCR_DETAILS.FULFILLED:
      return {
        ...state,
        isFetchDataLoading: false,
        documentDetails: action.documentDetails || defaultState.documentDetails,
      };
    case TYPES.FETCH_FCR_DETAILS.REJECTED:
      return {
        ...state,
        isFetchDataLoading: false,
        isFetchDataError: true,
        detailsPendingError: action.errors,
      };
    case TYPES.FETCH_FCR_DETAILS.RESET_ERROR:
      return {
        ...state,
        isFetchDataError: true,
        detailsPendingError: action.errors,
      };
    default:
      return state;
  }
};
